<!--
TODO: refactor (too long, move search form/results to components)
-->
<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12">
          <!-- <search-form> -->
          <v-card class="px-5 pt-5 grey lighten-5">
            <v-row @keyup.enter="searchJobs">
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.jobNr" label="Job #" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.clientRef" label="Client Ref #" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.name" label="Customer" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.address" label="Address" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.townSuburb" label="Town" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-autocomplete background-color="white" clearable outlined dense
                  label="State" v-model="filters.state" autocomplete="state_"
                  :items="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NZ']" />
              </v-col>
              <v-col cols="12" md="6" class="py-0 mt-n3">
                <v-radio-group :mandatory="true" v-model="filters.openClosed" row>
                  <v-radio label="Open" value="open" />
                  <v-radio label="Closed" value="closed" />
                  <v-radio label="Both" value="both" />
                </v-radio-group>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-menu :close-on-content-click="false" v-model="startDateMenu">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateFormat(filters.startDateFrom)"
                      @click:clear="filters.startDateFrom = null"
                      label="From Date"
                      persistent-hint
                      v-on="on"
                      clearable
                      outlined
                      background-color="white"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.startDateFrom"
                    @input="startDateMenu = false" no-title />
                </v-menu>
              </v-col>
              <v-col cols="2" class="py-0">
                <v-menu :close-on-content-click="false" v-model="endDateMenu">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="dateFormat(filters.startDateTo)"
                      @click:clear="filters.startDateTo = null"
                      label="To Date"
                      persistent-hint
                      v-on="on"
                      clearable
                      outlined
                      background-color="white"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.startDateTo"
                    @input="endDateMenu = false" no-title />
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.product" label="Product" />
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <v-text-field background-color="white" clearable outlined dense
                  v-model="filters.supplierTitle" label="Service Agent" />
              </v-col>
              <v-col cols="12" md="2" class="py-0 text-right">
                <v-btn color="info" @click="searchJobs">Search</v-btn>
              </v-col>
            </v-row>
          </v-card>
          <!-- </search-form> -->
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col>
          <!-- <search-results> -->
          <v-card class="px-4 py-2">
            <v-toolbar flat>
              <v-text-field v-model="search" placeholder="Filter" class="mt-2"
                append-icon="mdi-magnify" clearable />
              <v-spacer />
              <JsonCSV class="ml-3" :data="exportedJobs" title="Download CSV"
                :labels="exportJobsLabels" ref="download">
                <v-icon color="white">mdi-file-chart</v-icon>
              </JsonCSV>
              <v-spacer />
              <v-btn class="mb-2 mr-3" @click="exportJobs" :loading="exportLoading">
                Export
              </v-btn>
            </v-toolbar>
            <v-data-table
              :headers="headers"
              :items="jobs"
              :items-per-page="15"
              class="hover-cursor-pointer"
              :loading="loading"
              :search="search"
              @click:row="handleClick">
              <template v-slot:item.startDate="{ item }">
                {{ dateFormat(item.startDate) }}
              </template>
            </v-data-table>
          </v-card>
          <!-- </search-results> -->
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import * as queries from '@/utils/queries';
import * as labels from '@/utils/labels';
import { components } from 'aws-amplify-vue';
import { API, graphqlOperation } from 'aws-amplify';
import JsonCSV from 'vue-json-csv';

export default {
  props: ['api_endpoint'],
  components: {
    JsonCSV,
    ...components,
  },
  data() {
    return {
      startDateMenu: false,
      endDateMenu: false,
      filters: {
        openClosed: 'both',
      },
      search: null,
      heading: 'Jobs',
      breadcrumbs: [
        { text: 'Dashboard', to: '/', exact: true },
        { text: 'Jobs', disabled: true },
      ],
      jobs: [],
      headers: [
        { text: 'Job #', value: 'jobNr', filterable: true },
        { text: 'Opened', value: 'startDate' },
        { text: 'Client Ref', value: 'clientRef' },
        { text: 'Customer', value: 'name' },
        { text: 'Products', value: 'products' },
        { text: 'Suburb', value: 'townSuburb' },
        { text: 'Status', value: 'status' },
        { text: 'Priority', value: 'priority' },
        { text: 'Service Agent', value: 'supplierTitle' },
      ],
      nr_found: 0,
      loading: true,
      source: 'home',
      exportLoading: false,
      exportedJobs: [],
      exportJobsLabels: labels.exportJobsLabels,
    };
  },
  mounted() {
    if (this.$store.state.details) {
      this.searchJobs();
    } else {
      this.$store.watch(() => this.$store.state.details, () => { // wait for details to load
        if (this.$store.state.details) {
          this.searchJobs();
        }
      });
    }
  },
  methods: {
    handleClick(row) {
      this.$router.push({ name: 'job_details', params: { id: row.id } });
    },
    async searchJobs() {
      this.loading = true;
      const searchFilters = this.getSearchFilters();
      const searchQuery = Object.keys(searchFilters).length > 0 ? { filter: searchFilters } : {};
      searchQuery.limit = 500;
      searchQuery.sort = {
        field: 'startDate',
        direction: 'desc',
      };
      const response = await API.graphql(graphqlOperation(queries.SearchJobs, searchQuery));
      this.jobs = JSON.parse(JSON.stringify(response.data.searchJobs.items));
      this.jobs.forEach((job, i) => {
        this.jobs[i].products = job.product2 ? [job.product, job.product2].join(', ') : job.product;
      });
      this.nr_found = this.jobs.length;
      this.loading = false;
    },
    getSearchFilters() {
      const searchFilters = {};
      Object.keys(this.filters).forEach((key) => {
        if (this.filters[key]) {
          const value = this.filters[key];
          switch (key) {
            case 'startDateFrom':
              if ('startDateTo' in this.filters) {
                searchFilters.and = [
                  { startDate: { gte: value } },
                  { startDate: { lte: this.filters.startDateTo } },
                ];
              } else {
                searchFilters.startDate = { gte: value };
              }
              break;
            case 'startDateTo':
              searchFilters.startDate = { lte: value };
              break;
            case 'openClosed':
              if (this.filters[key] === 'open') {
                searchFilters.not = { closed: { gte: null } };
              } else if (this.filters[key] === 'closed') {
                searchFilters.closed = { gte: null };
              }
              break;
            case 'product':
              searchFilters.or = [
                { product: { matchPhrasePrefix: value } },
                { product2: { matchPhrasePrefix: value } },
              ];
              break;
            default:
              searchFilters[key] = { matchPhrasePrefix: value };
              break;
          }
        }
      });
      searchFilters.jobClientId = { eq: this.$store.state.details.id };
      return searchFilters;
    },
    async exportJobs() {
      this.exportLoading = true;
      const searchFilters = this.getSearchFilters();
      const searchQuery = Object.keys(searchFilters).length > 0 ? { filter: searchFilters } : {};
      searchQuery.limit = 500;
      searchQuery.sort = {
        field: 'startDate',
        direction: 'desc',
      };
      await API.graphql(
        graphqlOperation(queries.ExportJobs, searchQuery),
      ).then((response) => {
        this.exportedJobs = [];
        for (let i = 0; i < response.data.searchJobs.items.length; i += 1) {
          const job = response.data.searchJobs.items[i];
          this.exportedJobs.push({
            jobNr: job.jobNr,
            startDate: job.startDate,
            closed: job.closed,
            name: job.name,
            address: job.address,
            townSuburb: job.townSuburb,
            state: job.state,
            postcode: job.postcode,
            email: job.email,
            product: job.product,
            product2: job.product2,
            status: job.status,
            priority: job.priority,
            clientRef: job.clientRef,
            serviceAgent: job.supplierTitle,
            faultInformation: job.faultInformation,
            description: job.description,
            parts: job.parts ? job.parts.items.map((p) => `${this.moment(p.dateOrdered).format('D MMM Y h:mma')} - ${p.quantity} x ${p.partOrdered}`).join('\n') : '',
            datePurchased: job.datePurchased,
            purchasedFrom: job.purchasedFrom,
            finalKpa: job.finalKpa,
          });
        }
      }).finally(() => {
        this.$refs.download.$el.click();
        this.exportLoading = false;
      });
    },
  },
};
</script>
